// 编辑图片
import SECTIONB_3 from '@/assets/section/b_3.jpg';
import SECTIONB_4 from '@/assets/section/b_4.jpg';
import SECTIONB_5 from '@/assets/section/b_5.png';

import N1 from '@/assets/doc/1.svg';
import N2 from '@/assets/doc/2.svg';
import N3 from '@/assets/doc/3.svg';
import N4 from '@/assets/doc/4.svg';
import N5 from '@/assets/doc/5.svg';

export const EDIT_IMAGES = [
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/f0ed069cdabd2345381c656361210c57.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/92cbca616308c68e09f11df8505d2592.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/bb9de9050c223564e2de0eafc038bff0.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/c5e8591f2b415e8fbd8e24c8256db339.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/f0ed069cdabd2345381c656361210c57.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/92cbca616308c68e09f11df8505d2592.jpg~tplv-1rgwpn4pta-image-v1:900:0.image',
];
// 创意图片
export const CREATIVE_IMAGES = [
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/a3da032b5db7f7d3d2e97d53cc1976b7.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/4ebfe6f85e39320c59c0f4334c75e6b7.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/2ee1830add4abbc48aee5632f526277a.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/f05ef8285edf3b7e44d31aa635919623.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/a3da032b5db7f7d3d2e97d53cc1976b7.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
  '//p3-tada-queen.byteimg.com/tos-cn-i-1rgwpn4pta/4ebfe6f85e39320c59c0f4334c75e6b7.jpeg~tplv-1rgwpn4pta-image-v1:900:0.image',
];

export const SECTIONB_DATA = [
  {
    id: 1,
    image: SECTIONB_3,
    title: '设计工具',
    desc: '为设计工具等平台提供多样化素材供应，满足平台服务的不同的用户群体提供多样化选择',
  },
  {
    id: 2,
    image: SECTIONB_4,
    title: '媒体用户',
    desc: '与媒体客户素材中心无缝衔接，多种频道组图供选择，实现一站式文章配图服务',
  },
  {
    id: 3,
    image: SECTIONB_5,
    title: '企业用户',
    desc: '为企业级客户媒体发文，内部宣传，微信公众号对外宣传等场景，提供不同行业丰富资源，满足使用需求',
  },
];

export const STEPS = [
  {
    id: 1,
    text: '阅读API接口文档并确认功能',
    icon: N1,
  },
  {
    id: 2,
    text: '与客户经理取得联系',
    icon: N2,
  },
  {
    id: 3,
    text: '确定合作方式及优惠',
    icon: N3,
  },
  {
    id: 4,
    text: '开始试用',
    icon: N4,
  },
  {
    id: 5,
    text: '正式接入',
    icon: N5,
  },
];

const DEPLOY_ENV = process.env.DEPLOY_ENV || 'prod';

export const urlMap = new Map([
  [
    'contributor',
    {
      test: 'https://contributor-test.tucdev.com',
      prod: 'https://contributor.tuchong.com',
    }[DEPLOY_ENV]
  ]
]);
